<div>
  <div>
    <ion-label>{{ headerTitle.unitName }}</ion-label>
  </div>
  <div [style.font-size]="unitStatusFontSize">
    <ion-label>{{ headerTitle.unitStatus }}</ion-label>
  </div>
</div>
